const LOAD_KILLSWITCHES = 'loadKillswitches';
const UPDATE_KILLSWITCHES = 'updateKillswitches';

export { LOAD_KILLSWITCHES, UPDATE_KILLSWITCHES };
